var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11599_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35376 0.354093L7.99966 0L7.64557 0.354093L3.6346 4.36506L3.28051 4.71915L3.98869 5.42734L4.34279 5.07325L7.49829 1.91774V10.4849V10.9863H8.50103V10.4849V1.91774L11.6565 5.07325L12.0106 5.42734L12.7188 4.71915L12.3647 4.36506L8.35376 0.354093ZM1.98321 10.4849V9.98355H0.980469V10.4849V15.4986V16H1.48184H14.5175H15.0189V15.4986V10.4849V9.98355H14.0161V10.4849V14.9973H1.98321V10.4849Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11599_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.3cd815c9f7f8d752fb69dbc36ce3e540.svg";
export { ForwardRef as ReactComponent };